import {useLocalization} from "../../../hooks/localization"

export const useStaticData = () => {
    const {t} = useLocalization()
    const hours = [
        "00:00-00:59",
        "01:00-01:59",
        "02:00-02:59",
        "03:00-03:59",
        "04:00-04:59",
        "05:00-05:59",
        "06:00-06:59",
        "07:00-07:59",
        "08:00-08:59",
        "09:00-09:59",
        "10:00-10:59",
        "11:00-11:59",
        "12:00-12:59",
        "13:00-13:59",
        "14:00-14:59",
        "15:00-15:59",
        "16:00-16:59",
        "17:00-17:59",
        "18:00-18:59",
        "19:00-19:59",
        "20:00-20:59",
        "21:00-21:59",
        "22:00-22:59",
        "23:00-23:59"
    ]
    const days = [
        t("energy_page.mon"),
        t("energy_page.tue"),
        t("energy_page.wed"),
        t("energy_page.thu"),
        t("energy_page.fri"),
        t("energy_page.sat"),
        t("energy_page.sun")
    ]
    const months = [
        t("energy_page.january"),
        t("energy_page.february"),
        t("energy_page.march"),
        t("energy_page.april"),
        t("energy_page.may"),
        t("energy_page.june"),
        t("energy_page.july"),
        t("energy_page.august"),
        t("energy_page.september"),
        t("energy_page.october"),
        t("energy_page.november"),
        t("energy_page.december")
    ]
    const staticDatas = {days, hours, months}
    return staticDatas
}
export default useStaticData
